import { DateTime } from 'luxon'

export const formattedDateTime = (timestamp, options = {}) => {
    const datetime = DateTime.fromMillis(timestamp, { zone: 'utc' })
    
    if (options.dateLabel) return datetime.setZone('utc').toLocaleString({ month: 'long', day: 'numeric', weekday: 'long' })
    else if (options.date) return datetime.setZone('utc').toFormat('yyyy-MM-dd')
    else if (options.time) return datetime.setZone('utc').toFormat('HH:mm')
    else return datetime.setZone('utc').toFormat('yyyy-MM-dd HH:mm')
}